import React, { useEffect, useState } from "react";
import { CustomTab } from "../../../components/CustomTab/CustomTab";
import CrmSettingsHeader from "./CrmSettingsHeader";
import CrmLeadSource from "./CrmLeadSource/CrmLeadSource";
import {
  closeAllModals,
  getCurrentWorkspaceId,
  startApiCall,
} from "../../../global-functions/globalFunctions";
import {
  CrmSettingsRelatedEndPoints,
  DynamicEmailRelatedEndPoints,
  LeadRelatedEndPoints,
  businessEndpoints,
} from "../../../api/Endpoints";
import ApiCall from "../../../api/ApiCall";
import FooterPagination from "../../../components/Pagination/FooterPagination";
import DataLoader from "../../../components/Loaders/DataLoader/DataLoader";
import NoData from "../../../components/NoData/NoData";
import AddLeadSource from "./CrmLeadSource/AddLeadSource";
import { toast } from "react-toastify";
import CrmLeadGenerationTarget from "./CrmLeadGenerationTarget/CrmLeadGenerationTarget";
import { useSelector } from "react-redux";
import CrmDynamicFields from "./CrmDynamicFields/CrmDynamicFields";
import CreateDynamicFields from "./CrmDynamicFields/CreateDynamicFields";
import PRIVATEROUTES from "../../../components/Constant/Route-Constants";
import CrmLeadVisibility from "./CrmLeadVisibility/CrmLeadVisibility";
import MailTemplates from "./MailTemplates/MailTemplates";
import AddMailTemplate from "./MailTemplates/AddMailTemplate";
import MailTemplateDetailsModal from "./MailTemplates/MailTemplateDetailsModal/MailTemplateDetailsModal";

const CrmSettings = () => {
  const { user, allModuleAccess } = useSelector((state) => state);
  const [loader, setloader] = useState(false);
  const [loader3, setloader3] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // ** PAGINATION **
  const [page, setPage] = useState(1);
  const [pageLimit, setpageLimit] = useState(30);
  const [count, setcount] = useState(0);
  const [totalPages, settotalPages] = useState(0);
  const [loader2, setloader2] = useState(false);
  const [businessDetails, setBusinessDetails] = useState([]);
  const [dynamicFieldsModal, setdynamicFieldsModal] = useState(false);
  const [editData, seteditData] = useState("");
  const [allFields, setallFields] = useState([]);
  const [allLeadSource, setAllLeadSource] = useState([]);
  const [editLeadSource, setEditLeadSource] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [mailTemplateLoader, setMailTemplateLoader] = useState(false);
  const [mailTemplateErrorMessage, setMailTemplateErrorMessage] = useState("");
  const [mailTemplateConfirmModal, setMailTemplateConfirmModal] =
    useState(false);

  const [addMailTemplateModal, setAddMailTemplateModal] = useState(false);
  const [allMailTemplates, setAllMailTemplates] = useState([]);
  const [editMailTemplate, setEditMailTemplate] = useState("");
  const [mailTemplateId, setMailTemplateId] = useState("");
  const [mailTemplatePage, setMailTemplatePage] = useState(1);
  const [mailTemplatePageLimit, setMailTemplatePageLimit] = useState(30);
  const [mailTemplateCount, setMailTemplateCount] = useState(0);
  const [mailTemplateTotalPages, setMailTemplateTotalPages] = useState(0);
  const [templateDetailsModal, setTemplateDetailsModal] = useState(false);

  // ******DYNAMIC FIELDS PAGINATION ******
  const [fieldsCount, setfieldsCount] = useState(0);
  const [fieldsTotalPages, setfieldsTotalPages] = useState(0);

  const isModuleReadWriteAccessForSetting =
    allModuleAccess?.[PRIVATEROUTES.CRM_SETTINGS];

  const handleClose = () => {
    setIsOpen(false);
    setErrorMessage("");
    setloader(false);
  };

  // Tab
  const [status, setStatus] = useState("leadSource");
  const handleTabChange = (status) => {
    setStatus(status);
  };
  const allTabs = [
    {
      name: "Lead / Deal Source",
      value: "leadSource",
    },
    {
      name: "Generation Target",
      value: "generationTarget",
    },
    {
      name: "Dynamic Fields",
      value: "dynamicFields",
    },
    {
      name: "Lead Visibility",
      value: "leadVisibility",
    },
    {
      name: "Mail Templates",
      value: "mailTemplates",
    },
  ];

  const handleGetDynamicFields = async () => {
    startApiCall(null, setloader3);
    const data = {
      page: page,
      limit: pageLimit,
      filters: {
        businessId: getCurrentWorkspaceId(),
      },
    };
    const res = await ApiCall(
      "post",
      CrmSettingsRelatedEndPoints.getAllFields,
      data
    );
    if (res?.success) {
      setallFields(res?.customField?.data);
      setfieldsCount(res?.customField?.totalCounts);
      setfieldsTotalPages(res?.customField?.totalPages);
      setloader3(false);
    } else {
      setloader3(false);
    }
  };

  useEffect(() => {
    if (getCurrentWorkspaceId() && status === "dynamicFields") {
      handleGetDynamicFields();
    }
  }, [status, page, pageLimit]);

  const handleGetAllLeadSource = async () => {
    startApiCall(null, setloader);
    const sendData = {
      page: 1,
      limit: 50,
      filters: {
        businessId: getCurrentWorkspaceId(),
      },
    };
    const res = await ApiCall(
      "post",
      LeadRelatedEndPoints.getLeadSource,
      sendData
    );
    if (res?.success) {
      setAllLeadSource(res?.result?.data);
      settotalPages(res?.result?.totalPages);
      setcount(res?.result?.totalCounts);
      setloader(false);
    } else {
      setloader(false);
    }
  };
  useEffect(() => {
    if (getCurrentWorkspaceId() && status === "leadSource") {
      handleGetAllLeadSource();
    }
  }, [page, pageLimit]);

  const handleDeleteLeadSource = async () => {
    startApiCall(setErrorMessage, setloader);
    const data = {
      leadOrDealId: editLeadSource?._id,
      type: "lead",
    };
    const res = await ApiCall(
      "post",
      LeadRelatedEndPoints.removeLeadSource,
      data
    );
    if (res?.success) {
      toast.success("Lead Source deleted successfully!");
      handleGetAllLeadSource();
      handleClose();
    } else {
      setloader(false);
      setErrorMessage("");
    }
  };
  const handleGetBusinessDetails = async () => {
    startApiCall(null, setloader2);
    const data = {
      businessId: getCurrentWorkspaceId(),
      employeeId: user?._id,
    };
    const res = await ApiCall("post", businessEndpoints.getBusinessById, data);
    if (res?.success) {
      setBusinessDetails(res?.business?.businessId);
      setloader2(false);
    } else {
      setloader2(false);
    }
  };

  useEffect(() => {
    if (status === "generationTarget" || status === "leadVisibility") {
      handleGetBusinessDetails();
      closeAllModals();
    }
  }, [status]);

  // Mail Template
  const handleMailTemplateConfirmModalClose = () => {
    setMailTemplateConfirmModal(false);
  };

  const handleGetAllMailTemplates = async () => {
    startApiCall(null, setMailTemplateLoader);
    const data = {
      page: mailTemplatePage,
      limit: mailTemplatePageLimit,
      filters: { isDeleted:false},
    };
    const res = await ApiCall(
      "post",
      DynamicEmailRelatedEndPoints?.getDynamicEmailTemplate,
      data
    );
    if (res?.success) {
      setAllMailTemplates(res?.result?.docs);
      setMailTemplateCount(res?.result?.totalDocs);
      setMailTemplateTotalPages(res?.result?.totalPages);
      setMailTemplateLoader(false);
    } else {
      setMailTemplateLoader(false);
    }
  };

  useEffect(() => {
    if (status === "mailTemplates") {
      handleGetAllMailTemplates();
    }
  }, [mailTemplatePage, mailTemplatePageLimit, status]);

  const handleDeleteMailTemplate = async () => {
    startApiCall(setMailTemplateErrorMessage, setMailTemplateLoader);
    const data = {
      dynamicemailId: mailTemplateId,
    };
    const res = await ApiCall(
      "post",
      DynamicEmailRelatedEndPoints?.deleteDynamicEmailTemplate,
      data
    );
    if (res?.success) {
      toast.success("Mail Template deleted successfully!");
      handleGetAllMailTemplates();
      handleMailTemplateConfirmModalClose();
    } else {
      setMailTemplateLoader(false);
      setMailTemplateErrorMessage("");
    }
  };

  const handleRefresh = () => {
    handleGetAllLeadSource();
  };

  return (
    <div className="todoapp-wrap">
      <div className="todoapp-content">
        <div className="todoapp-detail-wrap">
          <CrmSettingsHeader
            handleRefresh={handleRefresh}
            status={status}
            handleGetBusinessDetails={handleGetBusinessDetails}
            setdynamicFieldsModal={setdynamicFieldsModal}
            handleGetDynamicFields={handleGetDynamicFields}
            isModuleReadWriteAccessForSetting={
              isModuleReadWriteAccessForSetting
            }
            setAddMailTemplateModal={setAddMailTemplateModal}
            handleGetAllMailTemplates={handleGetAllMailTemplates}
          />

          <CustomTab
            allTabs={allTabs}
            currentTab={status}
            handleTabChange={handleTabChange}
            isShowCount={true}
          />
          <div className="todo-body">
            <div data-simplebar className="nicescroll-bar simple-scrollbar">
              {status === "leadSource" && (
                <>
                  {!loader && allLeadSource?.length > 0 && (
                    <CrmLeadSource
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      handleClose={handleClose}
                      allLeadSource={allLeadSource}
                      page={page}
                      pageLimit={pageLimit}
                      handleDeleteLeadSource={handleDeleteLeadSource}
                      loader={loader}
                      errorMessage={errorMessage}
                      setEditLeadSource={setEditLeadSource}
                      isModuleReadWriteAccessForSetting={
                        isModuleReadWriteAccessForSetting
                      }
                    />
                  )}
                  {!loader && allLeadSource?.length > 0 && (
                    <FooterPagination
                      setpageLimit={setpageLimit}
                      pageLimit={pageLimit}
                      setPage={setPage}
                      page={page}
                      totalPages={totalPages}
                      count={count}
                      dataLength={allLeadSource?.length}
                      align={"end"}
                    />
                  )}
                  {loader && <DataLoader title="data is loading..." />}
                  {!loader && allLeadSource?.length === 0 && (
                    <NoData title="No Lead Source Added" />
                  )}
                </>
              )}

              {status === "generationTarget" && (
                <>
                  {loader2 ? (
                    <DataLoader title="data is loading..." />
                  ) : (
                    <CrmLeadGenerationTarget
                      businessDetails={businessDetails}
                      handleGetBusinessDetails={handleGetBusinessDetails}
                      isModuleReadWriteAccessForSetting={
                        isModuleReadWriteAccessForSetting
                      }
                    />
                  )}
                </>
              )}

              {status === "dynamicFields" && (
                <>
                  <CrmDynamicFields
                    allFields={allFields}
                    setdynamicFieldsModal={setdynamicFieldsModal}
                    seteditData={seteditData}
                    totalPages={fieldsTotalPages}
                    count={fieldsCount}
                    editData={editData}
                    loader3={loader3}
                    page={page}
                    setPage={setPage}
                    pageLimit={pageLimit}
                    setpageLimit={setpageLimit}
                    handleGetDynamicFields={handleGetDynamicFields}
                    isModuleReadWriteAccessForSetting={
                      isModuleReadWriteAccessForSetting
                    }
                  />
                </>
              )}
              {status === "leadVisibility" && (
                <>
                  {loader2 ? (
                    <DataLoader title="data is loading..." />
                  ) : (
                    <CrmLeadVisibility
                      businessDetails={businessDetails}
                      handleGetBusinessDetails={handleGetBusinessDetails}
                      isModuleReadWriteAccessForSetting={
                        isModuleReadWriteAccessForSetting
                      }
                    />
                  )}
                </>
              )}

              {status === "mailTemplates" && (
                <>
                  <MailTemplates
                    mailTemplateLoader={mailTemplateLoader}
                    allMailTemplates={allMailTemplates}
                    setEditMailTemplate={setEditMailTemplate}
                    mailTemplateConfirmModal={mailTemplateConfirmModal}
                    setMailTemplateConfirmModal={setMailTemplateConfirmModal}
                    setMailTemplateId={setMailTemplateId}
                    handleMailTemplateConfirmModalClose={
                      handleMailTemplateConfirmModalClose
                    }
                    mailTemplateErrorMessage={mailTemplateErrorMessage}
                    handleDeleteMailTemplate={handleDeleteMailTemplate}
                    setAddMailTemplateModal={setAddMailTemplateModal}
                    setTemplateDetailsModal={setTemplateDetailsModal}
                    mailTemplatePage={mailTemplatePage}
                    mailTemplatePageLimit={mailTemplatePageLimit}
                  />

                  {!mailTemplateLoader && allMailTemplates?.length > 0 && (
                    <FooterPagination
                      setpageLimit={setMailTemplatePageLimit}
                      pageLimit={mailTemplatePageLimit}
                      setPage={setMailTemplatePage}
                      page={mailTemplatePage}
                      totalPages={mailTemplateTotalPages}
                      count={mailTemplateCount}
                      dataLength={allMailTemplates?.length}
                      align={"end"}
                    />
                  )}
                  {!mailTemplateLoader && allMailTemplates?.length === 0 && (
                    <NoData title="No Mail Template Added" />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {dynamicFieldsModal && (
          <CreateDynamicFields
            setdynamicFieldsModal={setdynamicFieldsModal}
            editData={editData}
            seteditData={seteditData}
            handleGetDynamicFields={handleGetDynamicFields}
          />
        )}
        <AddLeadSource
          handleGetAllLeadSource={handleGetAllLeadSource}
          editLeadSource={editLeadSource}
          setEditLeadSource={setEditLeadSource}
          handleGetAllMailTemplates={handleGetAllMailTemplates}
        />

        <AddMailTemplate
          handleGetAllMailTemplates={handleGetAllMailTemplates}
          editMailTemplate={editMailTemplate}
          addMailTemplateModal={addMailTemplateModal}
          setAddMailTemplateModal={setAddMailTemplateModal}
          setEditMailTemplate={setEditMailTemplate}
        />

        {templateDetailsModal && (
          <MailTemplateDetailsModal
            setTemplateDetailsModal={setTemplateDetailsModal}
            editMailTemplate={editMailTemplate}
          />
        )}
      </div>
    </div>
  );
};

export default CrmSettings;
